import { type ITableInputWidget } from '../ITableInputWidget.ts';
import { type ITableRow } from '../ITableRow.ts';

// TODO Rimuovere `rowIndex` e mettere `row.id`
export function materializeTableWidgetRowPrefix(
  table: ITableInputWidget,
  row: ITableRow,
  rowIndex: number,
) {
  return `${table.code}_${row.code ?? rowIndex}`;
}
